@if (this.data$ | async; as data) {
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    @for (element of elements; track element) {
      @if (isInputRadioElement(element)) {
        <input type="radio" formControlName="{{element.name}}"
          [value]="element.value !== '' ? element.value : null"
          [attr.id]="element.id !== '' ? element.id : null"
          [attr.style]="element.style !== '' ? element.style : null"
          [attr.class]="element.class !== '' ? element.class : null"
          [attr.readonly]="element.readonly !== '' ? element.readonly : null"
          [attr.required]="element.required !== '' ? element.required : null">
        }
        @if (isInputCheckboxElement(element)) {
          <input type="checkbox" [value]="element.value !== '' ? element.value : null" name="{{element.name}}"
            (change)="onCheckboxChange($event)" [attr.id]="element.id !== '' ? element.id : null"
            [attr.style]="element.style !== '' ? element.style : null"
            [attr.class]="element.class !== '' ? element.class : null"
            [attr.readonly]="element.readonly !== '' ? element.readonly : null"
            [attr.required]="element.required !== '' ? element.required : null"
            [attr.checked]="element.checked !== '' ? element.checked : null">
          }
          @if (isOtherInputElement(element)) {
            <input type="{{element.type}}" formControlName="{{element.name}}"
              [attr.value]="element.value !== '' ? element.value : null"
              [attr.id]="element.id !== '' ? element.id : null"
              [attr.style]="element.style !== '' ? element.style : null"
              [attr.class]="element.class !== '' ? element.class : null"
              [attr.readonly]="element.readonly !== '' ? element.readonly : null"
              [attr.required]="element.required !== '' ? element.required : null"
              [attr.size]="element.size !== '' ? element.size : null"
              [attr.maxlength]="element.maxlength !== '' ? element.maxlength : null"
              [attr.min]="element.min !== '' ? element.min : null"
              [attr.max]="element.max !== '' ? element.max : null"
              [attr.multiple]="element.multiple !== '' ? element.multiple : null"
              [attr.pattern]="element.pattern !== '' ? element.pattern : null"
              [attr.placeholder]="element.placeholder !== '' ? element.placeholder : null"
              [attr.step]="element.step !== '' ? element.step : null"
              [attr.autofocus]="element.autofocus !== '' ? element.autofocus : null"
              [attr.list]="element.list !== '' ? element.list : null"
              [attr.autocomplete]="element.autocomplete !== '' ? element.autocomplete : null">
            }
            @if (isTextareaElement(element)) {
              <textarea formControlName="{{element.name}}" [attr.id]="element.id !== '' ? element.id : null"
                [attr.style]="element.style !== '' ? element.style : null"
                [attr.class]="element.class !== '' ? element.class : null"
                [attr.rows]="element.rows !== '' ? element.rows : null"
                [attr.cols]="element.cols !== '' ? element.cols : null"
                [attr.readonly]="element.readonly !== '' ? element.readonly : null"
                [attr.required]="element.required !== '' ? element.required : null">
              </textarea>
            }
            @if (isSelectElement(element)) {
              <select formControlName="{{element.name}}" [attr.id]="element.id !== '' ? element.id : null"
                [attr.style]="element.style !== '' ? element.style : null"
                [attr.class]="element.class !== '' ? element.class : null"
                [attr.readonly]="element.readonly !== '' ? element.readonly : null"
                [attr.required]="element.required !== '' ? element.required : null"
                [attr.size]="element.size !== '' ? element.size : null"
                [multiple]="element.multiple !== '' ? element.multiple : null">
                @for (option of element.options; track option) {
                  <option [attr.value]="option.value !== '' ? option.value : null"
                    [attr.disabled]="option.disabled !== '' ? option.disabled : null"
                    [selected]="option.selected !== '' ? option.selected : null"
                  [innerHTML]="option.innerHTML | safeHtml"></option>
                }
              </select>
            }
            @if (isHtmlElement(element)) {
              <span [innerHTML]="element.content | safeHtml"></span>
            }
          }
        </form>
      }